import FormSection from '@/components/Forms/FormSection';
import { CheckboxInput } from '@palmetto/palmetto-components';
import { Controller, useFormContext } from 'react-hook-form';

type AttestationSectionProps = {
  projectAttestLabel: string;
  isSubmitting: boolean;
  isPackageEditable?: boolean;
  onOpenAttestation?: () => void;
  onClearAttestation?: () => void;
};

export const AttestationSection = ({
  projectAttestLabel,
  isSubmitting,
  isPackageEditable = true,
  onOpenAttestation,
  onClearAttestation,
}: AttestationSectionProps) => {
  const { control } = useFormContext<any>();

  return (
    <FormSection title="Project Attestation">
      <Controller
        name="projectAttestationCheckbox"
        control={control}
        rules={{ required: 'Attestation is a required field.' }}
        render={({ field, fieldState }) => (
          <CheckboxInput
            id="projectAttestationCheckbox"
            name="projectAttestationCheckbox"
            label={projectAttestLabel}
            onChange={(event) => {
              if (event.target.checked) {
                onOpenAttestation?.();
              } else {
                field.onChange(false);
                onClearAttestation?.();
              }
            }}
            isChecked={Boolean(field.value)}
            isDisabled={isSubmitting || !isPackageEditable}
            error={fieldState.isTouched && fieldState.error?.message}
          />
        )}
      />
    </FormSection>
  );
};
